module.exports = __webpack_public_path__ + "static/img/project.700a9e8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/daoFund/project.png
 ** module id = 582
 ** module chunks = 2
 **/